import Vue from 'vue'
export default Vue.extend({
  data: () => ({
    formattedTrn: '',
    maxTRNLength: 9,
    formattedPhoneNumber: '876',
    maxPhoneNumberLength: 10
  }),
  methods: {
    unformatTrn(){
      this.formattedTrn = this._countDigits(this.formattedTrn).digits;
    },
    trnMatchPattern(trn: string){
      return /[0-9]{3}-[0-9]{3}-[0-9]{3}/.test(trn);
    },
    formatTrn(){
      this.formattedTrn = this.trnFormatting(this.formattedTrn);
    },
    trnFormatting(trn: string){
      if(!this.containNumberOnly(trn)){
        if(!this.trnMatchPattern(trn)) return '';
        return trn;
      }
      if(trn.length == this.maxTRNLength){
        const _1of3 = trn.slice(0,3)
        const _2of3 = trn.slice(3,6)
        const _3of3 = trn.slice(6)
        return `${_1of3}-${_2of3}-${_3of3}`;
      }

      return trn;
    },
    filterTrn(event: any){
      this.filterGivenTrn(event, this.formattedTrn);
    },
    filterGivenTrn(event: any, givenTrn: string){
      this._numberOnly(event);
      const trnLength = givenTrn.length;
      if(trnLength >= this.maxTRNLength) event.preventDefault();
    },
    formatPhoneNumber(){
      this.formattedPhoneNumber = this.phoneNumberFormatting(this.formattedPhoneNumber);
    },
    phoneNumberMatchPattern(phoneNumber: string): boolean{
      return /\([0-9]{3}\)\s[0-9]{3}-[0-9]{4}/.test(phoneNumber);
    },
    phoneNumberFormatting(phoneNumber: string){
      if(!this.containNumberOnly(phoneNumber)){
        if(!this.phoneNumberMatchPattern(phoneNumber)) return '';
        return phoneNumber;
      }
      if(phoneNumber.length == this.maxPhoneNumberLength){
        const _1of3 = phoneNumber.slice(0,3)
        const _2of3 = phoneNumber.slice(3,6)
        const _3of3 = phoneNumber.slice(6)
        return `(${_1of3}) ${_2of3}-${_3of3}`;
      }

      return phoneNumber;
    },
    unformatPhoneNumber(){
      this.formattedPhoneNumber = this._countDigits(this.formattedPhoneNumber).digits;
    },
    filterPhoneNumber(event: any){
      this.filterGivenPhoneNumber(event, this.formattedPhoneNumber);
    },
    filterGivenPhoneNumber(event: any, givenPhoneNumber: string){
      this._numberOnly(event);
      const phoneNumLength = givenPhoneNumber.length;
      if(phoneNumLength >= this.maxPhoneNumberLength) event.preventDefault();
    },
    _countDigits(input: string){
      let count = 0;
      let digits = ''
      for(let char of input){
        if(/[0-9]/.test(char)){
          digits += char;
          count++;
        }
      }
      return {
        count,
        digits
      }
    },
    _numberOnly(event: any){
      const key = event.key as string;
      if(!/[0-9]/.test(key))event.preventDefault();
    },
    containNumberOnly(input: string): boolean{
      for(let char of input){
        if(!/[0-9]/.test(char)) return false;
      }
      return true;
    }
  }
})

